// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="32"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
}

function modifySignup() {
  const signupWidget = $('.emailSignup');
  const input = signupWidget.find('.inputFieldTextbox');
  const submit = signupWidget.find('.emailSubmitButton');
  signupWidget.find('.emailSignupText').remove();
  input.val('');
  input.attr('placeholder', 'Email Address');
  submit.text('SUBSCRIBE');
  submit.attr('aria-label', 'Subscribe to newsletter');
}

// --------------------Lineup modifier----------------------//

function modifyFeatureLineup() {
  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() + 8 >= containerSize) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  searchBoxPlaceholder();
  modifySignup();
  // if is not homepage then modify featureLineup
  if (!$('body').hasClass('homepage')) {
    modifyFeatureLineup();
  }
});
